/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { Dialog, CardContent, Card } from "@mui/material";
import { useSnackbar } from "hooks/useSnackbar";
import { useAuth } from "cms/auth/hooks/use-auth";
import { LinkContext } from "cms/links/link-selector/context";
import LinkCreateContext from "cms/links/link-selector/context/create";
import LinkCreateHeader from "cms/links/link-selector/dialog-create/panels/link-create-header";
import LinkDialogBottomActions from "cms/links/link-selector/dialog-create/actions/link-dialog-bottom-actions";
import LinkCreateMainPanel from "cms/links/link-selector/dialog-create/panels/link-create-panel-main";
import { Logger } from "cms/utils/log/logger";

const LinkCreateDialog = () => {
    
    const {
        selectedLink,
        setSelectedLink,
        openCreate,
        handleCreateClose,
        MODES,
        setMode,
        setNeedsRefresh,
        startClone,
        setStartClone,
    } = useContext(LinkContext);

    const { token } = useAuth();
    const { showSnackbar } = useSnackbar();
    const [link, setLink] = useState();
    const [canSave, setCanSave] = useState(false);
    
    const onSelectLink = (e, link) => {
        e.stopPropagation();
        setSelectedLink(link);
    };
    const handleCancel = (e) => {
        setLink(undefined);
        handleCreateClose(e);
        setNeedsRefresh(true);
    };
    const onSaveLink = (payload) => {
        if (payload) {
            setSelectedLink(payload);
            SimpliCityAdminSDK.link.create(token, payload)
                .then((link) => {
                    Logger.debug("link result",link);
                    setSelectedLink(link);
                    handleCreateClose();
                });
        }
        // reload list
        setNeedsRefresh(true);
    };

    const createContext = {
        handleCreateClose,
        link,
        setLink,
        selectedLink,
        setSelectedLink,
        onSaveLink,
        onSelectLink,
        showSnackbar,
        MODES,
        setMode,
        canSave,
        setCanSave,
        startClone,
        setStartClone,
    };
    
    return (
        <>
            <Dialog
                open={openCreate}
                onClose={handleCancel}
                fullWidth={true}
                maxWidth='lg'
                className="simplicity-link-selector-overlay create"
            >
                <LinkCreateContext.Provider value={createContext}>

                    <Card elevation={0} className="simplicity-link-edit-window">
                        <CardContent sx={{ flex: "1 0 auto", height: "100%", padding: 0 }}>
                            
                            <LinkCreateHeader />
                            
                            <div className="simplicity-link-selector-create-content">
                                
                                <div className="simplicity-link-edit-window-active">
                                    
                                    <LinkCreateMainPanel />
                                
                                </div>
                            
                            </div>

                        </CardContent>
                    </Card>
                    
                    <LinkDialogBottomActions />
                    
                </LinkCreateContext.Provider>
            </Dialog>
        </>
    );
};

export { LinkCreateDialog };
